// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ygB3","notes":"Notes_notes__1czEQ"};